import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteAccountRoleAsync, getAccountRoleByAccountRoleIdAsync, checkedState, unCheckedState,updateSorting } from './roleSlice';
import clsx from 'clsx';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { setItemStatus,getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const RoleItem = (props: any) => {
    const { modelRef, roleDetail, IsEdit, IsDelete, t, onopenModal } = props;
    const { sortOrder, sortColumn,pageSize } = useAppSelector((state) => state.role);

    const dispatch = useAppDispatch();

    const onDeleteClick =  (AccountRoleId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAccountRoleAsync(AccountRoleId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Role deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }
    
    const onEditClick = (AccountLocationId: number) => {
        dispatch(getAccountRoleByAccountRoleIdAsync(roleDetail.AccountRoleId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };
   
    return (
        <tr>
            <td>
                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(roleDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                    {roleDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                    
                    
                </span>
            </td>
            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                onClick={IsEdit ? () => onEditClick(roleDetail.AccountRoleId) : undefined}
            >
            <span className="d-block">{roleDetail.Role}</span>
            </td>
            <td><span className="d-block">{roleDetail.LDAPRole}</span></td>
            <td className='text-center'>
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                            {IsEdit &&
                                <>
                                    <div className='menu-hover-bg-sec'>
                                        <Dropdown.Item
                                            className="menu-item me-lg-0 "
                                            onClick={() => {
                                                dispatch(getAccountRoleByAccountRoleIdAsync(roleDetail.AccountRoleId))
                                                    .unwrap()
                                                    .then((originalPromiseResult) => {
                                                        onopenModal();
                                                    })
                                                    .catch((rejectedValueOrSerializedError) => {
                                                        console.log('getAccountRoleByAccountRoleIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                                                    })
                                            }}
                                        >
                                            <span className="menu-icon custom-menu">
                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title custom-menu-fontsize">
                                                {/* {`${t('Edit')}`} */}
                                                {getValueFromResource('Edit',dispatch, t)}

                                                </span>
                                        </Dropdown.Item>
                                    </div>
                                </>
                            }
                            {IsDelete && IsEdit && (roleDetail.MasterAccountRoleId === null || roleDetail.MasterAccountRoleId === 0) &&
                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                            }
                            {/* {IsDelete && */}
                            {IsDelete === true && (roleDetail.MasterAccountRoleId === null || roleDetail.MasterAccountRoleId === 0) &&
                                <>
                                    <div className='menu-hover-bg-danger'>
                                        <Dropdown.Item
                                            className="menu-item me-lg-0 "
                                            onClick={() => { onDeleteClick(roleDetail.AccountRoleId) }}>
                                            <span className="menu-icon  custom-menu">
                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </span>
                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                {/* {`${t('Delete')}`} */}
                                                {getValueFromResource('Delete',dispatch, t)}

                                                </span>
                                        </Dropdown.Item>
                                    </div>
                                </>
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                
            </td>
        </tr>
    )
}

export default RoleItem;